import React, { useState } from 'react'
import { Button, Modal, Spin, Checkbox, message, Form, Input } from 'antd'
// import IntlMessages from '../util/IntlMessages'
import ds from '../Services/DataServices'
// import { BEHAVIOUR_TYPE } from '../Services/DataServices'
import { useHistory } from 'react-router-dom'
import { useStore, useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import UserOutlined from '@ant-design/icons/lib/icons/UserOutlined'
import CloseOutlined from '@ant-design/icons/lib/icons/CloseOutlined'
import LockOutlined from '@ant-design/icons/lib/icons/LockOutlined'
import { getDecryptID } from '../appRedux/actions/GlobalMethods'
import { userSignIn, getMenu } from '../appRedux/actions/Auth'
import {
  isEmptyObject,
  getCurrentPageID
} from '../appRedux/actions/GlobalMethods'

const ForgetPassModal = props => {
  const { open, setClose, email } = props

  const dispatch = useDispatch()
  const history = useHistory()
  const [form] = Form.useForm()
  const FormItem = Form.Item
  const [getLoading, setLoading] = React.useState(false)
  const [isEmailDisplay, setEmailDisplay] = React.useState(true)
  const [storedEmail, setStoredEmail] = React.useState('')

  React.useEffect(() => {
    let mounted = true
    if (mounted && open && email) {
      form.setFieldsValue({ email: email })
    }
    return () => (mounted = false)
  }, [open])

  const onFinishFailed = errorInfo => {
    console.log('Failed:', errorInfo)
  }

  const onFinish = values => {
    const email = values.email ? values.email.trim().toLowerCase() : false
    const validate = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
      email ? email : ''
    )
    if (validate) {
      forgetPassService(email)
    } else {
      message.warn('Provide correct Email')
    }
  }

  async function forgetPassService (body) {
    setLoading(true)
    const req = ds.getForgetPassService(body)
    await req
      .then(res => {
        setLoading(false)
        if (
          res &&
          res.data &&
          res.data.msgCode &&
          res.data.msgCode == 'GENERAL_SUCCESS'
        ) {
          if (res.data.data) {
            message.success('Email has been sent to your email address')
          } else {
            message.info('Email does not exist')
          }
        } else {
          message.warn('Something went wrong')
        }
        onClosePopUp()
      })
      .catch(e => {
        setLoading(false)
        message.error('Something is not right')
      })
  }

  function onClosePopUp () {
    form.resetFields()
    setClose()
  }

  return (
    <Modal
      title={<strong>Forget Password</strong>}
      visible={open}
      onCancel={() => onClosePopUp()}
      centered={true}
      footer={
        <>
          <Form
            initialValues={{ remember: true }}
            form={form}
            name='emailForm'
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            className='input-grp'
          >
            <Button
              size='large'
              className='dk-btn-cancel'
              onClick={onClosePopUp}
            >
              Cancel
            </Button>
            <Button
              size='large'
              className='dk-btn-add'
              type='primary'
              htmlType='submit'
            >
              Submit
            </Button>
          </Form>
        </>
      }
    >
      <Spin tip={'Loading'} spinning={getLoading} size='large'>
        <label>Enter your Email Address</label>

        <Form
          initialValues={{ remember: true }}
          form={form}
          name='emailForm'
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          className='input-grp'
        >
          <FormItem
            rules={[{ required: true, message: 'Please input your E-mail!' }]}
            name='email'
            className='mb-0'
          >
            <Input className='' prefix={<UserOutlined />} placeholder='Email' />
          </FormItem>
        </Form>
      </Spin>
    </Modal>
  )
}

export default ForgetPassModal
